var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.data_content),callback:function ($$v) {_vm.data_content=$$v},expression:"data_content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }